/* Shared click/tap popover for [data-fw-tip] buttons, and exclusive
   accordion pairs inside [data-fw-exclusive]. */
(() => {
  const pop = document.createElement('div');
  pop.className = 'fw-tip-pop';
  pop.setAttribute('role', 'tooltip');
  pop.hidden = true;
  document.body.appendChild(pop);
  let openBtn = null;

  const close = () => {
    if (!openBtn) return;
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn = null;
    pop.hidden = true;
  };
  const open = (btn) => {
    close();
    pop.textContent = btn.dataset.fwTip;
    pop.hidden = false;
    const r = btn.getBoundingClientRect();
    const w = Math.min(280, window.innerWidth - 32);
    pop.style.width = w + 'px';
    const alignStart = btn.hasAttribute('data-fw-tip-start');
    let left = alignStart ? r.left : r.left + r.width / 2 - w / 2;
    left = Math.max(16, Math.min(left, window.innerWidth - w - 16));
    pop.style.left = left + window.scrollX + 'px';
    pop.style.top = r.bottom + 10 + window.scrollY + 'px';
    const arrow = alignStart ? r.left + 11 - left : r.left + r.width / 2 - left;
    pop.style.setProperty('--fw-arrow-x', arrow + 'px');
    btn.setAttribute('aria-expanded', 'true');
    openBtn = btn;
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-fw-tip]');
    if (btn) { e.preventDefault(); e.stopPropagation(); openBtn === btn ? close() : open(btn); return; }
    if (!pop.contains(e.target)) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  window.addEventListener('resize', close);

  /* Desktop buy column: sticky with its top at (scroller height - column height),
     so it scrolls with the page until its bottom meets the bottom of the window and
     stays there while the photos go on scrolling. Re-measured as folds open and close. */
  const col = document.querySelector('.product-information .product-details.sticky-content--desktop');
  /* The space under the column (the section's padding below the photo grid):
     the column anchors that far above the bottom of the window, so its end
     keeps the same breathing room it has on the page. */
  let colGap = 0;
  if (col) {
    const scroller = col.closest('.page-wrapper');
    const section = col.closest('.shopify-section');
    const setTop = () => {
      const h = scroller ? scroller.clientHeight : window.innerHeight;
      if (section && col.parentElement) {
        colGap = Math.max(0, Math.round(section.getBoundingClientRect().bottom - col.parentElement.getBoundingClientRect().bottom));
      }
      col.style.setProperty('--fw-col-top', `${Math.round(h - col.offsetHeight - colGap)}px`);
    };
    new ResizeObserver(setTop).observe(col);
    window.addEventListener('resize', setTop);
    setTop();
  }

  document.querySelectorAll('[data-fw-exclusive]').forEach((group) => {
    const folds = [...group.querySelectorAll(':scope details')];
    /* Only a fold the shopper opens scrolls the page. Browsers fire 'toggle' for a fold that
       is open in the HTML (Pearl details) as the page loads, which scrolled phones and tablets
       down to it on arrival. */
    folds.forEach((f) => {
      const summary = f.querySelector(':scope > summary');
      if (summary) summary.addEventListener('click', () => { f.dataset.fwUserToggle = '1'; });
    });
    folds.forEach((f) => f.addEventListener('toggle', () => {
      const byUser = f.dataset.fwUserToggle === '1';
      delete f.dataset.fwUserToggle;
      if (!f.open) return;
      if (!byUser) return;
      /* A fold above this one closing (0.3s height transition, fw-brand-styles)
         shifts the page up, so the one just opened can land below the viewport.
         Once that collapse has settled, bring its heading to the top, under
         the header. */
      const aboveWasOpen = folds.slice(0, folds.indexOf(f)).some((o) => o.open);
      folds.forEach((o) => { if (o !== f) o.open = false; });
      const headerBottom = () => {
        const header = document.getElementById('header-component');
        return header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      };
      const aim = (behavior) => {
        f.style.scrollMarginTop = `${headerBottom() + 8}px`;
        f.scrollIntoView({ block: 'start', behavior });
      };
      /* Desktop: the buy column is anchored to the bottom of the window once it
         has scrolled up to it, after which scrolling down only moves the photos.
         So scroll by exactly what moves the heading: down, at most until the
         column anchors; up, the stuck stretch plus the distance to the header. */
      const col = f.closest('.product-details');
      const media = col && col.parentElement ? col.parentElement.querySelector('.product-information__media') : null;
      const scroller = f.closest('.page-wrapper') || document.scrollingElement;
      const step = (behavior) => {
        const desired = Math.round(f.getBoundingClientRect().top - (headerBottom() + 8));
        const cr = col.getBoundingClientRect();
        let delta = 0;
        if (desired > 2) delta = Math.min(desired, Math.max(0, Math.round(cr.bottom + colGap - window.innerHeight)));
        else if (desired < -2) delta = desired - (media ? Math.max(0, Math.round(cr.top - media.getBoundingClientRect().top)) : 0);
        if (Math.abs(delta) > 2) scroller.scrollBy({ top: delta, behavior });
      };
      const go = () => {
        if (window.innerWidth >= 900 && col) {
          /* One scroll once the fold's 0.3s open transition has finished and the
             column's anchor is re-measured (the wrapper scrolls smoothly, so a
             second scroll issued mid-animation would be dropped); a settle check
             after the animation. */
          setTimeout(() => {
            step('smooth');
            setTimeout(() => step('auto'), 900);
          }, 400);
          return;
        }
        aim('smooth');
        /* Settle: the column can still be reflowing while the smooth scroll runs,
           so re-aim once it has stopped. */
        setTimeout(() => {
          if (Math.abs(f.getBoundingClientRect().top - (headerBottom() + 8)) > 2) aim('auto');
        }, 700);
      };
      if (aboveWasOpen) setTimeout(go, 340); else requestAnimationFrame(go);
    }));
  });

})();
